import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {Divider} from '../../../../../../../../../commons/components/divider'
import {useCurrencyFormatter} from '../../../../../../../../../commons/hooks/currency'
import {getLabeledItemTicketPrice} from '../../../../../../../../../commons/selectors/order'
import {TicketInfoProps} from './interfaces'
import s from './ticket-info.scss'

export const TicketInfo = ({item}: TicketInfoProps) => {
  const {t} = useTranslation()
  const {getFormattedMoney} = useCurrencyFormatter()

  const getTicketAriaLabel = (priceText: string) => {
    const name = `${t('ticketsThankYou.ticketName')}: ${item.name}`

    const price = t('mobile.thanks.price', {
      price: getFormattedMoney(item.price),
    })

    const qty = t('mobile.thanks.quantity', {quantity: item.quantity})
    const total = `${t('mobile.thanks.total')} ${priceText}`

    return `${name}, ${price}, ${qty}, ${total}`
  }

  const ticketPrice = getLabeledItemTicketPrice(item, t, getFormattedMoney)

  const totalPrice = getFormattedMoney(item.total)

  return (
    <>
      <div
        className={s.container}
        data-hook={DH.ORDER_SUCCESS_SUMMARY}
        role="group"
        aria-label={getTicketAriaLabel(totalPrice)}
      >
        <div className={s.row} data-hook={DH.TICKET_NAME}>
          {item.name}
        </div>
        <div className={s.row}>
          {t('mobile.thanks.price', {price: ticketPrice, interpolation: {escapeValue: false}})}
        </div>
        <div className={s.row}>
          <div className={s.rowLeft}>{t('mobile.thanks.quantity', {quantity: item.quantity})}</div>
          <div className={s.rowRight}>{totalPrice}</div>
        </div>
      </div>
      <Divider />
    </>
  )
}
